// @flow

import React            from 'react';
import { connect }      from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import Reminder         from 'containers/insuranceInquiry/reminder.js';
import './actionStrip.css';

type Props = {
  translate: Function,
  currentApp: any,
  showReminder: boolean
};

const CalcIcon = () => (
  <svg className="calc-ico" width="34" height="34" viewBox="0 0 24 24" fill="none">
    <rect x="4" y="2" width="16" height="20" rx="2" stroke="#8cb81c" strokeWidth="2" />
    <rect x="7" y="5" width="10" height="4" rx="1" fill="#8cb81c" />
    <rect x="7" y="12" width="3" height="3" fill="#8cb81c" />
    <rect x="10.5" y="12" width="3" height="3" fill="#d94f3d" />
    <rect x="7" y="16" width="3" height="3" fill="#8cb81c" />
    <rect x="10.5" y="16" width="3" height="3" fill="#8cb81c" />
    <rect x="14" y="12" width="3" height="7" fill="#ecd400" />
  </svg>
);

const ActionStrip = ({ translate, currentApp, showReminder }: Props) => {

  const openCalculator = () => {
    // Click the real tab anchor rather than calling .tab('show') on it: a native
    // click runs every existing path — React's _setActiveTab (document title, and
    // the element _windowIsResized re-anchors the magic line to) and Bootstrap's
    // tab data-api (pane swap + the 'shown.bs.tab' underline animation).
    // .tab('show') skips the onClick, which left the underline snapping back to
    // Overblik on the next resize.
    const tab = document.querySelector('.sub-nav a[href="#tab-ii2"]');
    if( tab ) { tab.click(); }

    if( window.dataLayer ) {
      window.dataLayer.push({
        event: 'minside_calc_strip_click',
        order_id: currentApp ? currentApp.order_id : null
      });
    }
  };

  // The strip renders at every width; the cells stack below 1200px. It is the
  // only calculator and reminder entry point on Overblik, so nothing here may
  // be display:none — the reminder container also hosts #reminder-modal.
  return (
    <div className="action-strip">
      <div className="action-strip--cell action-strip--calc">
        <CalcIcon />
        <div className="action-strip--texts">
          <strong>{translate('calculator.strip_title')}</strong>
          <span>{translate('calculator.strip_subtitle')}</span>
        </div>
        <button type="button" className="btn btn-success" onClick={openCalculator}>
          {translate('calculator.strip_cta')}
        </button>
      </div>
      {showReminder && <Reminder variant="strip" />}
    </div>
  );
};

const mapStateToProps = state => ({
  translate : getTranslate(state.locale),
  currentApp: state.application.activeApplication
});

export { ActionStrip };
export default connect(mapStateToProps)(ActionStrip);



// WEBPACK FOOTER //
// ./src/components/main/InsuranceInquiry/actionStrip.js